import { createClient } from '@supabase/supabase-js';

// Reemplaza estos valores con tu URL y tu anon key de Supabase
const supabaseUrl = 'https://odczzalwlxkauqacnolq.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9kY3p6YWx3bHhrYXVxYWNub2xxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIyNTA3MjgsImV4cCI6MjA3NzgyNjcyOH0.o1VYQGWj-iqETM2ma_SMnwiBlaLN9tXua_g-3GRlihE';
export const supabase = createClient(supabaseUrl, supabaseKey);
